import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCommunityInfo, fetchWallets } from "./community-thunk";
import { ErrorType } from "@/shared/types";
import { CommunityState } from "../types/types";

const initialState: CommunityState = {
    isLoading: false,
    community: {
        bot_id: "",
        community_name: "",
        description: "",
        logo: "",
        main_bonus: "",
        section_name: "channel",
        type: "bank",
        information_link: "",
        bonuses: [],
        social_bonuses: [],
        is_verified: false,
        is_whitelist_enabled: false,
        is_promotions_enabled: false,
        is_user_creation_enabled: false,
        is_admin_profile_fill_enabled: false,
        default_group_id: null,
    },
    error: null,
    wallet: {},
    masterWallet: 0
}

const communitySlice = createSlice({
    name: 'community',
    initialState,
    reducers: {
        updateWhitelistStatus: (state, action: PayloadAction<boolean>) => {
            state.community.is_whitelist_enabled = action.payload;
        },
        updateDefaultGroupId: (state, action: PayloadAction<string | null>) => {
            state.community.default_group_id = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCommunityInfo.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCommunityInfo.fulfilled, (state, action) => {
                state.isLoading = false
                state.community = action.payload
                state.error = null
            })
            .addCase(fetchCommunityInfo.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as ErrorType ?? null
            })
            .addCase(fetchWallets.fulfilled, (state, action) => {
                state.masterWallet = action.payload.masterWallet
                state.wallet = action.payload.wallet
            })
    },
})

export default communitySlice.reducer
export const { updateWhitelistStatus, updateDefaultGroupId } = communitySlice.actions